export const legendKeyMap = {
  SmartPhone: 'Smartphone',
};
